import styled from 'styled-components';

export const Title = styled.h1`
  color: ${props => props.theme.carvana.darkBlue4};
  font-size: 1.9rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  margin-top: 0;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: ${props => props.theme.carvana.grayEighteen};
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  margin-top: 0;
  text-align: center;
`;
